import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import SJHeader from '@product-framework/components/SJFormHandler/SJHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb, useLocalization, useStore } from '@ui-framework/index';
import {
  Layout,
  StackablePageButtons,
  PageSection,
  useServiceJob,
  ServiceJobProvider,
  AvailabilitySlotTypeProvider,
} from '@product-framework/index';
import { FormattedMessage } from 'react-intl';
import AssignWizard from '../../components/AssignWizard';
import AssignReAssignHelper from '../../lib/AssignReAssignHelper';
import { ServiceProviderProvider } from '../../../../providers/ServiceProviderProvider';
import ServiceJobAssignCheck from '../../components/ServiceJobAssignCheck';

function ServiceJobAssignReAssignContent({
  locationId,
  isReAssign = false,
  isAssign = false,
}) {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const { serviceJob } = useServiceJob();

  const store = useStore();

  const breadCrumb = AssignReAssignHelper.getBreadcrumb({
    formatMessage,
    navigate,
    store,
    serviceJob,
  });

  const stackablePageButtons = AssignReAssignHelper.getStackableButton({
    formatMessage,
    serviceJob,
    navigate,
    locationId,
  });

  let pageTitle = (
    <FormattedMessage id="ASSIGN_JOB" defaultMessage="Assign Job" />
  );
  if (isReAssign) {
    pageTitle = (
      <FormattedMessage id="REASSIGN_JOB" defaultMessage="Reassign Job" />
    );
  }

  return (
    <Box>
      <Grid2 container mb={1.5}>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      <SJHeader formData={serviceJob} sx={{ marginBottom: '10px' }} />
      <Grid2>
        <PageSection label={pageTitle}>
          <Box sx={{ mt: 2 }}>
            <AssignWizard
              locationId={locationId}
              isAssign={isAssign}
              isReAssign={isReAssign}
            />
          </Box>
        </PageSection>
      </Grid2>
    </Box>
  );
}

function ServiceJobAssignReassign({ isAssign = false, isReAssign = false }) {
  const { id: pageId, serviceProviderId, locationId } = useParams();

  return (
    <Layout>
      <ServiceJobProvider serviceJobId={pageId}>
        <ServiceProviderProvider
          serviceProviderId={serviceProviderId}
          loadProfileWarnings={false}
          loadDispatch
          loadSPInfo
          loadUser={false}
          loadLocation={false}>
          <ServiceJobAssignCheck
            isAssign={isAssign}
            isReAssign={isReAssign}
            serviceProviderId={serviceProviderId}
            locationId={locationId}>
            <AvailabilitySlotTypeProvider>
              <ServiceJobAssignReAssignContent
                isAssign={isAssign}
                isReAssign={isReAssign}
                locationId={locationId}
              />
            </AvailabilitySlotTypeProvider>
          </ServiceJobAssignCheck>
        </ServiceProviderProvider>
      </ServiceJobProvider>
    </Layout>
  );
}

export default observer(ServiceJobAssignReassign);
